import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import VideoRule1 from "@/assets/custom-digital-human-rule/video_rule_1.webp";
import VideoRule2 from "@/assets/custom-digital-human-rule/video_rule_1@2x.webp";
import VideoRule3 from "@/assets/custom-digital-human-rule/video_rule_1@3x.webp";

export const VideoRule1Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[VideoRule3]}
      {...props}
    />
  );
};

VideoRule1Image.displayName = 'VideoRule1Image';
